export default "__VITE_ASSET__DLPhB2vR__"